import * as React from 'react';
import { useEffect, useState } from 'react';
import { gray } from '../../../consts/variables';
import { __ } from '../../../helpers/TranslationService';
import { useTypedSelector } from '../../../hooks/useTypedSelector';
import { WaypointsTable } from './WaypointsTable';

const style: React.CSSProperties = {
    border: `1px solid ${gray}`,
};

interface IProps {
    collapsed?: boolean[];
    setCollapsed?: Function;
}

const Waypoints = (props: IProps) => {
    const { cruisePage } = useTypedSelector((state) => state);
    const { waypoints } = cruisePage;
    const routeImage = cruisePage?.routeImage ?? cruisePage.images?.[0];
    const collapsedArr =
        props?.collapsed?.length > 0
            ? props.collapsed
            : [...Array(waypoints.length).keys()].map((_) => true);
    const [state, setState] = useState({
        collapsedArr: collapsedArr,
    });

    const onHeaderClick = (index: number) => {
        const updateCollapsedArr = [...state.collapsedArr];
        updateCollapsedArr[index] = !updateCollapsedArr[index];
        if (props.setCollapsed) {
            props.setCollapsed(updateCollapsedArr);
        }
        setState({
            ...state,
            collapsedArr: updateCollapsedArr,
        });
    };

    return (
        <div className="waypointsSection">
            <h2 className="waypoints-title">{__('Itinerary', 'dreamlines')}</h2>
            <div style={style} className="waypoints-container">
                {Boolean(routeImage) && (
                    <img className="has-routes-image" src={routeImage} alt="Cruise Waypoints" />
                )}

                <WaypointsTable
                    waypoints={waypoints}
                    onHeaderClick={onHeaderClick}
                    collapsedArr={state.collapsedArr}
                />
            </div>
        </div>
    );
};
export default Waypoints;
